import { render, staticRenderFns } from "./IPISearch.vue?vue&type=template&id=e083c9d6&scoped=true&"
import script from "./IPISearch.vue?vue&type=script&lang=js&"
export * from "./IPISearch.vue?vue&type=script&lang=js&"
import style0 from "./IPISearch.vue?vue&type=style&index=0&id=e083c9d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e083c9d6",
  null
  
)

export default component.exports